//Univeral Functions
function navpad() {
    var height = $('#nav').outerHeight();
    $('#nav-pad').height(height);
}
$(document).ready(function() {
    navpad();
});
$(window).resize(function() {
    navpad();
});
$(window).scroll(function() {
    navpad();
    if ($(document).scrollTop() == 0) {
        $('body').removeClass('scrolling');
    } else {
        $('body').addClass('scrolling');
    }
});